export const initActiveLink = () => {
  const pageLinks = document.querySelectorAll('a[aria-current="page"]');

  pageLinks.forEach((link) => {
    link.classList.add('active');
  });
};
